import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button } from '@origo/origo-ui';
import type { DocumentFormValues } from '../../../types';
import DocumentForm, { type DocumentFieldErrors } from './DocumentForm';

interface NewDocumentDialogProps {
    open: boolean;
    values: DocumentFormValues;
    file: File | null;
    fieldErrors: DocumentFieldErrors;
    fileError?: string;
    onChange: (field: keyof DocumentFormValues, value: string) => void;
    onFileChange: (file: File | null) => void;
    onClose: () => void;
    onSave: () => void;
    isSaving?: boolean;
}

/** Opprett nytt plandokument (F3.1). Native <dialog> via origo-ui Dialog. */
const NewDocumentDialog: React.FC<NewDocumentDialogProps> = ({
    open,
    values,
    file,
    fieldErrors,
    fileError,
    onChange,
    onFileChange,
    onClose,
    onSave,
    isSaving = false,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('documents.new.title')}
            footer={
                <>
                    <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="primary" onClick={onSave} disabled={isSaving}>
                        {t('documents.new.submit')}
                    </Button>
                </>
            }
        >
            <DocumentForm
                values={values}
                file={file}
                fieldErrors={fieldErrors}
                fileError={fileError}
                onChange={onChange}
                onFileChange={onFileChange}
            />
        </Dialog>
    );
};

export default NewDocumentDialog;
